import {HttpError} from "./HttpError";

export class AuthenticationError extends HttpError {}
